// extracted by mini-css-extract-plugin
export default {"container":"MobileScreen_container__IEN-u","main":"MobileScreen_main__vLdwM","header":"MobileScreen_header__cbQPw"};